module.exports = __webpack_public_path__ + "media/images/fundraise/fundraise-img-01-00b97dbc45f3488ab6ae937d9d5e1aa6.jpg";